import store from '../../redux/store';
import * as actionTypes from '../../redux/actionTypes';

export const initDebugCommands = () => {
  if (typeof window === 'undefined') return;

  window.mockScavengerDrops = (totalDrops = 5, dropsCollectedByOthers = 2) => {
    const mockDrops = [];
    
    // Generate drops
    for (let i = 0; i < totalDrops; i++) {
      const isCollectedByOther = i < dropsCollectedByOthers;
      const baseLatitude = -20.1705;
      const baseLongitude = 57.4970;
      
      const drop = {
        id: 999000 + i,
        latitude: (baseLatitude - (i * 0.0003)).toString(),
        longitude: (baseLongitude + (i * 0.0002)).toString(),
        active: true,
        collection_type: "scavenger_hunt_competition",
        show_on_map: isCollectedByOther
      };
      
      // Add collection data for drops collected by others
      if (isCollectedByOther) {
        const aliens = ['green_alien1', 'purple_alien1', 'red_alien1', 'blue_alien1'];
        const alienNames = ['Green Fugi', 'Purple Fugi', 'Red Fugi', 'Blue Fugi'];
        const alienIndex = i % aliens.length;
        
        drop.image_url = `https://frodobots-assets.s3.ap-southeast-1.amazonaws.com/nft_collections_images/${aliens[alienIndex]}.jpg`;
        drop.nft_collection = {
          id: 12 + i,
          description: alienNames[alienIndex],
          image_url: drop.image_url
        };
        drop.scavenger_item = {
          id: 99000 + i,
          user_id: 99999, // Different user ID
          reached_at: new Date(Date.now() - (i * 60000)).toISOString() // Stagger the times
        };
      }
      
      mockDrops.push(drop);
    }
    
    store.dispatch({
      type: actionTypes.SCAVENGER_DROPS,
      payload: mockDrops
    });
    
    console.log(`Mock scavenger drops loaded: ${totalDrops} total, ${dropsCollectedByOthers} collected by others`);
    console.log('Drop positions:', mockDrops.map(d => ({
      id: d.id,
      lat: d.latitude,
      lng: d.longitude,
      collected: !!d.scavenger_item
    })));
  };

  window.simulateDropReached = (options = {}) => {
    const {
      dropId = 'test-drop-' + Date.now(),
      itemName = 'Test NFT Drop',
      itemDescription = 'This is a simulated drop for testing',
      imageUrl = 'https://picsum.photos/400/400',
      distributionType = 'uniform',
      active = false,
      mintStatus = 'pending'
    } = options;

    console.log('🎯 Simulating /reached drop point with options:', options);

    const mockDrop = {
      id: dropId,
      active: active,
      scavenger_item: {
        id: 'item-' + dropId,
        name: itemName,
        description: itemDescription,
        image_url: imageUrl,
        mint_status: mintStatus,
        created_at: new Date().toISOString()
      },
      nft_collection: {
        id: 'collection-' + dropId,
        name: itemName + ' Collection',
        description: 'NFT Collection for ' + itemName,
        distribution_type: distributionType,
        image_url: imageUrl
      },
      location: {
        lat: 0,
        lng: 0
      },
      created_at: new Date().toISOString()
    };

    const mockResponse = {
      scavenger_drops: [mockDrop]
    };

    console.log('📦 Mock response:', mockResponse);

    const currentState = store.getState();
    const currentDrops = currentState.missionDetail.scavengerDrops || [];
    const reachedDropsList = currentState.missionDetail.reachedNftDropsList || [];

    store.dispatch({
      type: actionTypes.SCAVENGER_DROPS,
      payload: mockResponse.scavenger_drops
    });
    
    store.dispatch({
      type: actionTypes.REACHED_SCAVENGER_DROPS_CHECKPOINT,
      payload: true
    });
    
    store.dispatch({
      type: actionTypes.REACHED_SCAVENGER_DROPS_CHECKPOINT_DATA,
      payload: mockDrop
    });

    if (distributionType === 'uniform' && !reachedDropsList.includes(dropId)) {
      console.log('🎉 Showing immediate drop notification for uniform distribution item');
      
      store.dispatch({
        type: actionTypes.REACHED_LATEST_NFT_DROPS_CHECKPOINT,
        payload: {
          scavenger_item: mockDrop.scavenger_item,
          nft_collection: mockDrop.nft_collection,
          image_url: null,
          scavenger_drop: mockDrop
        }
      });
      
      store.dispatch({
        type: actionTypes.REACHED_NFT_DROPS,
        payload: true
      });
      
      store.dispatch({
        type: actionTypes.REACHED_NFT_DROPS_LIST,
        payload: dropId
      });
    }

    console.log('✅ Drop simulation complete! Check the UI for visual feedback.');
    console.log('💡 Tip: Use window.simulateDropReached({ itemName: "Custom Item", distributionType: "dynamic" }) to customize');
    
    return mockDrop;
  };

  window.simulateDropTakenByOther = (options = {}) => {
    const {
      dropId = 'taken-drop-' + Date.now(),
      itemName = 'Drop Taken by Other User',
      itemDescription = 'This drop was claimed by someone else',
      imageUrl = 'https://picsum.photos/400/400',
      distributionType = 'uniform',
      active = false,
      otherUserId = 'user-123',
      otherUserName = 'OtherPlayer'
    } = options;

    console.log('🎯 Simulating drop taken by another user with options:', options);

    const mockDrop = {
      id: dropId,
      active: active,
      latitude: '41.718',
      longitude: '44.800',
      scavenger_item: {
        id: 'item-' + dropId,
        name: itemName,
        description: itemDescription,
        image_url: imageUrl,
        user_id: otherUserId, // This is the key - different from current user
        mint_status: 'minted',
        created_at: new Date().toISOString()
      },
      nft_collection: {
        id: 'collection-' + dropId,
        name: itemName + ' Collection',
        description: 'NFT Collection for ' + itemName,
        distribution_type: distributionType,
        image_url: imageUrl
      },
      created_at: new Date().toISOString()
    };

    console.log('📦 Mock "taken" drop response:', mockDrop);

    const currentState = store.getState();
    const currentDrops = currentState.missionDetail.scavengerDrops || [];
    const updatedDrops = [...currentDrops, mockDrop];

    store.dispatch({
      type: actionTypes.SCAVENGER_DROPS,
      payload: updatedDrops
    });

    console.log('✅ "Taken" drop simulation complete! This drop should appear grayed out with a red checkmark.');
    console.log(`💡 Tip: The drop shows as taken by user ID: ${otherUserId}`);
    console.log('🗒️ Note: This drop should NOT appear in your drop list since it was taken by another user');
    console.log('🎯 Visual: Red checkmark should be positioned close to the drop image');
    
    return mockDrop;
  };

  window.simulateDropReached.help = () => {
    console.log(`
🎮 simulateDropReached() - Simulates reaching a drop point

Usage:
  window.simulateDropReached(options)

Options:
  {
    dropId: string,           // Unique ID for the drop (default: auto-generated)
    itemName: string,         // Name of the item (default: "Test NFT Drop")
    itemDescription: string,  // Description (default: "This is a simulated drop for testing")
    imageUrl: string,         // Image URL (default: random placeholder)
    distributionType: string, // "uniform" or "dynamic" (default: "uniform")
    active: boolean,          // Whether drop is still active (default: false)
    mintStatus: string        // "pending", "minting", "minted", "failed" (default: "pending")
  }

Examples:
  // Simple drop with defaults
  window.simulateDropReached()
  
  // Custom uniform drop (shows immediate popup)
  window.simulateDropReached({ 
    itemName: "Rare Sword", 
    itemDescription: "A legendary blade",
    distributionType: "uniform"
  })
  
  // Dynamic drop (no immediate popup)
  window.simulateDropReached({ 
    itemName: "Mystery Box",
    distributionType: "dynamic"
  })
  
  // Failed mint simulation
  window.simulateDropReached({
    itemName: "Broken Item",
    mintStatus: "failed"
  })
    `);
  };

  window.addSimulatedDrop = (options = {}) => {
    const {
      lat,
      lng,
      id = Date.now() + Math.floor(Math.random() * 1000),
      imageUrl,
      crimeSeverity = 'infraction',
      active = true,
      showOnMap = true,
      minimumBounty = 50,
      distance = 50 // meters from robot
    } = options;

    // If no coordinates provided, place near robot
    let latitude = lat;
    let longitude = lng;
    
    if (latitude === undefined || longitude === undefined) {
      const currentState = store.getState();
      const robotCord = currentState.robotDetails?.Cord;
      
      if (!robotCord || !robotCord[0] || !robotCord[1]) {
        console.error('❌ No coordinates provided and robot position not available.');
        console.log('💡 Tip: Provide lat/lng or make sure you are in a drive session.');
        return null;
      }
      
      const robotLng = robotCord[0]; // longitude
      const robotLat = robotCord[1]; // latitude
      
      // Calculate random position within distance meters from robot
      // Convert distance to degrees (rough approximation: 1 degree ≈ 111km)
      const metersPerDegree = 111000;
      const maxOffset = distance / metersPerDegree;
      
      // Random angle in radians
      const angle = Math.random() * 2 * Math.PI;
      
      // Random distance between 0 and max distance
      const actualDistance = Math.random() * maxOffset;
      
      // Calculate offset
      latitude = robotLat + (actualDistance * Math.cos(angle));
      longitude = robotLng + (actualDistance * Math.sin(angle));
      
      console.log(`📍 Placing drop ~${Math.round(actualDistance * metersPerDegree)} meters from robot`);
    }

    console.log('📍 Adding simulated drop point at coordinates:', { lat: latitude, lng: longitude });

    const newDrop = {
      id: id,
      active: active,
      start_time: new Date().toISOString(),
      end_time: new Date(Date.now() + 15 * 60 * 1000).toISOString(), // 15 minutes from now
      latitude: String(latitude),
      longitude: String(longitude),
      minimum_bounty: minimumBounty,
      show_on_map: showOnMap,
      collection_type: 'scavenger_hunt',
      crime_severity: crimeSeverity,
      score: 0
    };

    if (imageUrl) {
      newDrop.image_url = imageUrl;
    }

    const currentState = store.getState();
    const currentDrops = currentState.missionDetail.scavengerDrops || [];
    const updatedDrops = [...currentDrops, newDrop];

    store.dispatch({
      type: actionTypes.SCAVENGER_DROPS,
      payload: updatedDrops
    });

    console.log('✅ Drop point added! Total drops:', updatedDrops.length);
    console.log(`📋 Drop details: ${crimeSeverity}, ${minimumBounty} bounty${imageUrl ? ', custom image' : ''}`);
    
    return newDrop;
  };

  window.addSimulatedDrop.help = () => {
    console.log(`
📍 addSimulatedDrop() - Adds a simulated drop point to the map

Usage:
  window.addSimulatedDrop(options)

Optional Options:
  {
    lat: number,              // Latitude (if not provided, places near robot)
    lng: number,              // Longitude (if not provided, places near robot)
    id: number,               // Unique ID (default: auto-generated timestamp)
    imageUrl: string,         // Custom image URL for the drop
    crimeSeverity: string,    // "infraction" or "misdemeanor" (default: "infraction")
    active: boolean,          // Is drop active (default: true)
    showOnMap: boolean,       // Show on map (default: true)
    minimumBounty: number,    // Minimum bounty points (default: 50)
    distance: number          // Max distance from robot in meters (default: 50)
  }

Examples:
  // Place near robot with defaults (within 50m)
  window.addSimulatedDrop()
  
  // Place near robot with custom settings
  window.addSimulatedDrop({ 
    crimeSeverity: "misdemeanor",
    minimumBounty: 100,
    distance: 100  // Within 100 meters
  })
  
  // Place at specific coordinates
  window.addSimulatedDrop({ lat: 41.718, lng: 44.800 })
  
  // Add multiple drops around robot
  for (let i = 0; i < 5; i++) {
    window.addSimulatedDrop({ 
      distance: 30 + (i * 10),  // 30m, 40m, 50m, 60m, 70m
      crimeSeverity: i % 2 === 0 ? "infraction" : "misdemeanor"
    });
  }
    `);
  };

  window.clearSimulatedDrops = () => {
    const currentState = store.getState();
    const currentDrops = currentState.missionDetail.scavengerDrops || [];
    const realDrops = currentDrops.filter(drop => drop.id < 1000000); // Keep only real drops (with smaller IDs)
    
    store.dispatch({
      type: actionTypes.SCAVENGER_DROPS,
      payload: realDrops
    });
    
    console.log('🧹 Cleared all simulated drops. Remaining drops:', realDrops.length);
  };

  window.getCurrentRobotPosition = () => {
    const currentState = store.getState();
    const robotCord = currentState.robotDetails?.Cord;
    
    if (robotCord && robotCord[0] && robotCord[1]) {
      const longitude = robotCord[0];
      const latitude = robotCord[1];
      console.log('🤖 Current robot position:', { lat: latitude, lng: longitude });
      console.log(`📋 Copy this: { lat: ${latitude}, lng: ${longitude} }`);
      return { lat: latitude, lng: longitude };
    } else {
      console.log('❌ Robot position not available. Make sure you are in a drive session.');
      return null;
    }
  };

  window.simulateDropTakenByOther.help = () => {
    console.log(`
🎯 simulateDropTakenByOther() - Simulates a drop that was taken by another user

Usage:
  window.simulateDropTakenByOther(options)

Options:
  {
    dropId: string,           // Unique ID for the drop (default: auto-generated)
    itemName: string,         // Name of the item (default: "Drop Taken by Other User")
    itemDescription: string,  // Description (default: "This drop was claimed by someone else")
    imageUrl: string,         // Image URL (default: random placeholder)
    distributionType: string, // "uniform" or "dynamic" (default: "uniform")
    active: boolean,          // Whether drop is still active (default: false)
    otherUserId: string,      // User ID who took the drop (default: "user-123")
    otherUserName: string     // Display name of other user (default: "OtherPlayer")
  }

Examples:
  // Simple taken drop with defaults
  window.simulateDropTakenByOther()
  
  // Custom taken drop
  window.simulateDropTakenByOther({ 
    itemName: "Legendary Sword", 
    otherUserId: "player-456",
    otherUserName: "FastPlayer"
  })
    `);
  };

  window.getCompetitionPollingStatus = () => {
    const currentState = store.getState();
    const competition = currentState.missionDetail?.competition;
    const rideId = currentState.missionDetail?.createRide?.id;
    
    if (!competition) {
      console.log('🟡 No active competition detected');
      return { status: 'no_competition', competition: null, rideId };
    }
    
    const now = Date.now();
    const startTime = new Date(competition.start_time).getTime();
    const endTime = new Date(competition.end_time).getTime();
    
    if (now < startTime) {
      console.log('🟠 Competition not started yet');
      console.log(`🕰️ Starts in: ${Math.ceil((startTime - now) / 1000)} seconds`);
      return { status: 'not_started', competition, rideId, startsIn: startTime - now };
    } else if (now >= startTime && now < endTime) {
      console.log('🟢 Competition is ACTIVE - polling should be running');
      console.log(`🕰️ Ends in: ${Math.ceil((endTime - now) / 1000)} seconds`);
      return { status: 'active', competition, rideId, endsIn: endTime - now };
    } else {
      console.log('🔴 Competition has ended');
      return { status: 'ended', competition, rideId };
    }
  };

  window.manuallyFetchDrops = async () => {
    const currentState = store.getState();
    const rideId = currentState.missionDetail?.createRide?.id;
    
    if (!rideId) {
      console.error('❌ No active ride found - cannot fetch drops');
      return;
    }
    
    console.log('📥 Manually fetching scavenger drops...');
    
    try {
      // Import the API function
      const { getScavengerDrops } = await import('../../services/api');
      const dropsRes = await getScavengerDrops(rideId);
      
      if (dropsRes?.scavenger_drops) {
        const activeScavengerDrops = dropsRes.scavenger_drops.filter(i => i.active || (!i.active && i.scavenger_item));
        
        console.log(`📊 Raw API response: ${dropsRes.scavenger_drops.length} total drops`);
        console.log(`✅ Filtered to ${activeScavengerDrops.length} active drops`);
        
        // Check for drops with user_id (taken by others)
        const takenByOthers = activeScavengerDrops.filter(drop => 
          drop?.scavenger_item?.user_id && drop.scavenger_item.user_id !== store.getState().setUserDetails?.user?.id
        );
        
        if (takenByOthers.length > 0) {
          console.log(`🔴 Found ${takenByOthers.length} drops taken by other users:`);
          takenByOthers.forEach(drop => {
            console.log(`   - Drop ${drop.id}: taken by user ${drop.scavenger_item.user_id}`);
          });
        }
        
        store.dispatch({
          type: 'SCAVENGER_DROPS',
          payload: activeScavengerDrops
        });
        
        console.log('🔄 Redux state updated with latest drop statuses');
        console.log('Full drops data:', activeScavengerDrops);
        return activeScavengerDrops;
      } else {
        console.log('🟡 No drops returned from API');
        return [];
      }
    } catch (error) {
      console.error('❌ Error fetching drops:', error);
    }
  };

  window.compareDropStatuses = async () => {
    console.log('🔍 Comparing current vs fresh drop statuses...');
    
    const currentState = store.getState();
    const currentDrops = currentState.missionDetail?.scavengerDrops || [];
    const rideId = currentState.missionDetail?.createRide?.id;
    
    if (!rideId) {
      console.error('❌ No active ride found');
      return;
    }
    
    console.log(`📋 Current state: ${currentDrops.length} drops`);
    
    // Show current status
    currentDrops.forEach(drop => {
      const status = drop?.scavenger_item?.user_id 
        ? `taken by user ${drop.scavenger_item.user_id}`
        : 'available';
      console.log(`   - Drop ${drop.id}: ${status}`);
    });
    
    // Fetch fresh data
    console.log('📥 Fetching fresh data...');
    const freshDrops = await window.manuallyFetchDrops();
    
    // Compare changes
    if (freshDrops) {
      console.log('🔄 Comparing changes:');
      
      freshDrops.forEach(freshDrop => {
        const currentDrop = currentDrops.find(d => d.id === freshDrop.id);
        
        if (!currentDrop) {
          console.log(`➕ NEW drop ${freshDrop.id}`);
        } else {
          const oldStatus = currentDrop?.scavenger_item?.user_id || 'available';
          const newStatus = freshDrop?.scavenger_item?.user_id || 'available';
          
          if (oldStatus !== newStatus) {
            console.log(`🔄 CHANGED drop ${freshDrop.id}: ${oldStatus} → ${newStatus}`);
          }
        }
      });
    }
    
    return { before: currentDrops.length, after: freshDrops?.length || 0 };
  };

  console.log('🛠️  Debug commands initialized:');
  console.log('  - window.simulateDropReached() - Simulate reaching a drop');
  console.log('  - window.simulateDropTakenByOther() - Simulate drop taken by another user');
  console.log('  - window.addSimulatedDrop() - Add drop (near robot or specify coords)');
  console.log('  - window.clearSimulatedDrops() - Clear all simulated drops');
  console.log('  - window.getCurrentRobotPosition() - Get current robot coordinates');
  console.log('  - window.getCompetitionPollingStatus() - Check competition polling status');
  console.log('  - window.manuallyFetchDrops() - Manually fetch latest scavenger drops');
  console.log('  - window.compareDropStatuses() - Compare current vs fresh drop statuses');
  console.log('  - Type <command>.help() for detailed usage');
};
